import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  // The article list has no loading flag: the screen reads `articles` itself, `{}` while loading
  // and `null` after a failure.
  ...requestCases('GET_NEWS_ARTICLES', {
    flags: { loading: null, success: 'success', error: 'error' },
    loading: () => ({ articles: {} }),
    success: dataAs('articles'),
    failure: () => ({ articles: null }),
  }),
  ...requestCases('GET_TRANSLATED_MESSAGE'),

  UPDATE_TRANSLATED_MESSAGE: (state, action) => ({
    ...state,
    success: true,
    translatedArticles: action.payload && [...state.translatedArticles, action.payload],
    error: false,
  }),

  GET_MODAL_STATE: (state, action) => ({
    ...state,
    isShow: action.isOpen,
  }),
});
